import { useSuspenseQuery } from '@tanstack/react-query';

import { PublicationImpactFactor } from '@/module/Journal/components/PublicationImpactFactor';

import { Id } from '@feature/utils';

import { getReviewImpactFactorOptions } from '../model/ReviewQuery';

interface ReviewImpactFactorProps {
  reviewId: Id;
}

export function ReviewImpactFactor({ reviewId }: ReviewImpactFactorProps) {
  const { data } = useSuspenseQuery(getReviewImpactFactorOptions(reviewId));

  return <PublicationImpactFactor data={data} />;
}
